import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { Alert, Collapse, Form } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import { klass } from 'utils'

//TODO enable ESLint parser plugin "exportDefaultFrom"
export { default as FileInputBtn } from './FileInputBtn'
export { default as IconCheck } from './IconCheck'
export { default as InputRow } from './InputRow'
export { default as Label } from 'components/form/Label'
export { default as MoneyInput } from 'components/form/MoneyInput'
export { default as NumberSpinner } from './NumberSpinner'
export { default as RadioGroup } from './RadioGroup'

/**
 * A wrapper is needed so height animates over a single, padding-less element.
 * Anything inside may need to be wrapped in Form.Groups, to add proper spacing without using margins in the Collapse.
 */
export const FormCollapse = ({ secondary = false, children, ...props }) => (
	<Collapse {...props}>
		<div {...klass('collapse-wrapper', { secondaryBlock: secondary })}>{children}</div>
	</Collapse>
)
FormCollapse.propTypes    = {
	in       : PropTypes.bool.isRequired,
	secondary: PropTypes.bool,
}

export const CollapsibleAlert = ({ variant = 'warning', children, ...props }) => (
	<FormCollapse {...props}>
		<Alert variant="warning">{children}</Alert>
	</FormCollapse>
)
CollapsibleAlert.propTypes    = {
	in: FormCollapse.propTypes.in,
}

/**
 * A small inline element to show an icon with the "button" text besides it, making sure they never wrap so the icon always make sense together.
 * The icon already has proper sizing and spacing to fit inline.
 * @param icon {string|string[]}
 * @param noText {boolean}
 * @param flip {'horizontal'|'vertical'|'both'}
 * @param rotation {90|180|270}
 * @returns {JSX.Element}
 */
export const BtnDesc = ({ icon, noText = false, flip = null, rotation = null }) => {
	const IconEl = () => <Icon {...{ flip, rotation, icon }} size="sm" className="m-0" fixedWidth/>
	return noText?
		<IconEl/> :
		<span className="text-nowrap"><Trans><IconEl/> button</Trans></span>
}

BtnDesc.propTypes = {
	noText  : PropTypes.bool,
	rotation: PropTypes.oneOf([90, 180, 270]),
	flip    : PropTypes.oneOf(['horizontal', 'vertical', 'both']),
}

export const FormTip = ({ children, ...props }) => <Form.Text muted {...props}>{children}</Form.Text>
